module.exports = __webpack_public_path__ + "static/media/mopping.f6575d18.png";